module.exports = __webpack_public_path__ + "img/Banner.563afe2.jpg";